import { E_OFFICE_PREFIX_URL } from '../../e-office-layout/constants/config.e-office-layout'

export const DAT_XE_SHORT_PREFIX_URL = '/dat-xe'
export const DAT_XE_PREFIX_URL = `${E_OFFICE_PREFIX_URL}${DAT_XE_SHORT_PREFIX_URL}`
